import { Avatar, Box, Typography } from "@braintrust/braintrust-ui-components";
import { RouterLink } from "@js/components/link";
import type { EmployerReview } from "@js/types/employer";
import type { TalentReview } from "@js/types/reviews";

import { ReviewCardActionMenu } from "../review-card-action-menu";

import style from "./style.module.scss";

type ReviewerCardDataProps = {
  reviewer: TalentReview["reviewer"] | EmployerReview["reviewer"];
  isMobile: boolean;
  id: number;
  isOwnProfile: boolean;
  profileId: number;
};

export const ReviewerCardData = ({
  reviewer,
  isMobile,
  id,
  isOwnProfile,
  profileId,
}: ReviewerCardDataProps) => {
  const { public_name, introduction_headline, title, profile_url } = reviewer;

  return (
    <div className={style.reviewer}>
      <Avatar size="md" src={reviewer} />
      <div className={style.reviewerName}>
        <Typography
          component="p"
          fontWeight={500}
          to={profile_url}
          RouterLink={RouterLink}
          noTextDecoration
          sx={{ mt: { xs: 0, sm: 1 } }}
        >
          {public_name}
        </Typography>
        <Typography component="p" size="small" multilineEllipsis={2}>
          {introduction_headline || title}
        </Typography>
      </div>
      {isMobile && (
        <Box sx={{ ml: "auto" }}>
          <ReviewCardActionMenu
            id={id}
            isOwnProfile={isOwnProfile}
            profileId={profileId}
          />
        </Box>
      )}
    </div>
  );
};
